var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChapter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4737 5.26316H0V7.89474H14.4737V5.26316ZM14.4737 0H0V2.63158H14.4737V0ZM19.7368 10.5263V5.26316H17.1053V10.5263H11.8421V13.1579H17.1053V18.4211H19.7368V13.1579H25V10.5263H19.7368ZM0 13.1579H9.21053V10.5263H0V13.1579Z",
    fill: "#DCDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapter);
export default __webpack_public_path__ + "static/media/chapter.c3ddc3a136d5a07e6c3d5d6431f25ce0.svg";
export { ForwardRef as ReactComponent };